/* eslint-disable */

import irelandApi from '../irelandApi';

export const getArticlesHowToEarn = () => (dispatch) => {
  dispatch({type: 'GET_ARTICLES_HOW_TO_EARN_PENDING', payload: []});

  return irelandApi.get('/api/how_to_earn?location=website')
    .then((response) => {
      dispatch({type: 'GET_ARTICLES_HOW_TO_EARN_FULFILLED', payLoad: response.data.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_ARTICLES_HOW_TO_EARN_REJECTED', payLoad: error});
    });
};



// WEBPACK FOOTER //
// ./src/actions/how-to-earn.js